import { Vector3 } from 'three'

/**
 * Efficiently swaps Y and Z coordinates for all Vector3 objects in the given array.
 * Mutates the input array in-place for better performance.
 * 
 * @param vectors - Array of Vector3 objects to modify
 */
export default function swapVector3YZThenNegativeY(vectors: Vector3[]): void {
  let v: Vector3, temp: number
  for (let i = 0, len = vectors.length; i < len; i++) {
    v = vectors[i]
    temp = v.y
    v.y = -v.z
    v.z = temp
  }
}
